<template>
  <!-- 用户管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <el-button
          class="topAn"
          type="primary"
          size="mini"
          plain
          @click="addUser"
        >
          <i class="el-icon-plus"></i>添加用户
        </el-button>
        <!-- 筛选 -->
        <div class="screening_box topAn">
          <el-input
            class="screen_input"
            v-model="searchFrom.user_name"
            placeholder="请输入用户名/登陆账号/使用人/昵称"
            clearable
            @change="search"
          ></el-input>
          <!-- <el-input v-model="searchFrom.login_name" placeholder="请输入登陆账号" @change='search'></el-input> -->
          <!-- <el-input v-model="searchFrom.createname" placeholder="使用人或昵称" @change='search'></el-input> -->
          <el-select
            v-model="searchFrom.company_id"
            filterable
            :disabled="!isAdmin"
            placeholder="请选择公司"
            @change="selectCompany"
          >
            <el-option
              :label="company.companyname"
              :value="company.companyid"
              v-for="company in search_companyList"
              :key="company.companyid"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!-- 用户列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
          stripe
        >
          <el-table-column label="是否方舟" width="80">
            <template slot-scope="scope">
              {{ scope.row.isMatrix == 1 ? "是" : "-" }}
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            prop="userid"
            :show-overflow-tooltip="true"
            label="用户ID"
          >
          </el-table-column>
          <el-table-column
            prop="username"
            label="用户名"
            show-overflow-tooltip
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="loginname"
            show-overflow-tooltip
            label="登陆账号"
          >
          </el-table-column>
          <el-table-column prop="companyname" label="公司"> </el-table-column>
          <el-table-column label="微信用户数量">
            <template slot-scope="scope">
              <div class="wx_userNum">
                <span>{{ scope.row.userWxSum ? scope.row.userWxSum : 0 }}</span>
                <el-button
                  class="btn"
                  size="mini"
                  @click.stop="lookUser(scope.row, scope.$index)"
                  >查看</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="desc" show-overflow-tooltip label="备注">
          </el-table-column>
          <el-table-column align="right" label="操作" width="300">
            <template slot-scope="scope">
              <template>
                <div class="btn_box">
                  <el-button
                    size="mini"
                    style="margin-left: 0px;"
                    @click.stop="mailbox(scope.row)"
                    >预警邮箱</el-button
                  >
                  <el-button
                    size="mini"
                    style="margin-left: 0px;"
                    @click.stop="clickChangePwd(scope.$index, scope.row)"
                    >修改密码</el-button
                  >
                  <el-button
                    size="mini"
                    style="margin-left: 0px;"
                    @click.stop="handleEdit(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    :hideIcon="true"
                    title="确定删除吗？"
                    @confirm="confirmDelete"
                  >
                    <el-button
                      slot="reference"
                      size="mini"
                      type="danger"
                      @click.stop="handleDelete(scope.$index, scope.row)"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </div>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="page"
        :pageSize="pageSize"
        @change="changePage"
      />

      <!-- 添加/编辑用户 -->
      <el-dialog
        :title="is_add ? '添加用户' : '编辑用户'"
        width="70%"
        top="5vh"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <el-form
          class="editFrom_box"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="form_left">
            <!-- 用户id -->
            <el-form-item label="用户id" prop="userid">
              <el-input
                v-model="ruleForm.userid"
                placeholder="请输入用户id"
                clearable
              >
                <el-button slot="append" @click="createId">生成id</el-button>
              </el-input>
            </el-form-item>
            <!-- 用户名 -->
            <el-form-item label="用户名" prop="username">
              <el-input
                v-model="ruleForm.username"
                placeholder="请输入用户名"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 公司 -->
            <el-form-item label="公司" prop="companyid" v-if="is_add">
              <el-select
                v-model="companyname"
                filterable
                :disabled="!isAdmin"
                placeholder="请选择公司"
                @change="changeSelect"
              >
                <el-option
                  :label="company.companyname"
                  :value="company.companyid"
                  v-for="company in company_list"
                  :key="company.companyid"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 登陆账号 -->
            <el-form-item label="登陆账号" prop="loginname">
              <el-input
                v-model="ruleForm.loginname"
                placeholder="请输入登陆账号"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 登陆密码 -->
            <el-form-item label="登陆密码" prop="password" v-if="is_add">
              <el-input
                v-model="ruleForm.password"
                placeholder="请输入登陆密码"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="form_right">
            <!-- 是否方舟 -->
            <el-form-item label="是否方舟" style="margin-bottom: 0">
              <el-switch
                class="switch"
                style="margin-right: 10px"
                v-model="ruleForm.isMatrix"
                active-color="#525F7F"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注">
              <el-input
                v-model="ruleForm.desc"
                placeholder="请输入备注"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 使用人 -->
            <el-form-item label="使用人" show-overflow-tooltip v-if="is_add">
              <el-input
                v-model="ruleForm.createname"
                placeholder="请输入使用人"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 手机号码 -->
            <el-form-item label="手机号码" show-overflow-tooltip v-if="is_add">
              <el-input
                type="number"
                v-model="ruleForm.phone"
                placeholder="请输入手机号码"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 是否永久 -->
            <el-form-item label="是否永久" prop="losetime" v-if="is_add">
              <el-switch
                class="switch"
                style="margin-right: 10px"
                v-model="ruleForm.losestatus"
                active-color="#525F7F"
                active-value="0"
                inactive-value="1"
                @change="switchChange($event, 'user')"
              >
              </el-switch>
              <el-date-picker
                v-if="ruleForm.losestatus == 1"
                v-model="ruleForm.losetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                :clearable="true"
                placeholder="请选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="submitForm"
            >{{ is_add ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>

      <!-- 修改用户密码 -->
      <el-dialog
        title="修改密码"
        :visible.sync="changePwd_show"
        @close="cancelChangePwd"
      >
        <el-form :model="pwdForm" :rules="rules" ref="pwdForm">
          <!-- 用户名 -->
          <el-form-item label="新密码" prop="pwd">
            <el-input
              v-model="pwdForm.pwd"
              placeholder="请输入新密码"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelChangePwd">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="cahngePwd"
            >确 定 修 改</el-button
          >
        </div>
      </el-dialog>

      <!-- 查看微信用户 -->
      <el-dialog
        :title="user_name"
        top="15vh"
        width="95%"
        :visible.sync="userDet_show"
      >
        <el-dialog
          width="40%"
          :title="is_editWx ? '编辑使用人' : '添加使用人'"
          :close-on-click-modal="false"
          @close="cancelChangeWx"
          :visible.sync="innerVisible"
          append-to-body
        >
          <el-form :model="wxName_form" :rules="rules" ref="wxName_form">
            <!-- 使用人 -->
            <el-form-item label="使用人" prop="createname">
              <el-input
                v-model="wxName_form.createname"
                placeholder="请输入使用人"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 手机号 -->
            <el-form-item label="手机号">
              <el-input
                maxlength="11"
                v-model="wxName_form.phone"
                placeholder="请输入手机号"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 是否永久 -->
            <el-form-item label="是否永久" prop="losetime">
              <el-switch
                class="switch"
                style="margin-right: 10px"
                v-model="wxName_form.losestatus"
                active-color="#525F7F"
                active-value="0"
                inactive-value="1"
                @change="switchChange($event, 'wx')"
              >
              </el-switch>
              <el-date-picker
                v-if="wxName_form.losestatus == 1"
                v-model="wxName_form.losetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                :clearable="true"
                placeholder="请选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="cancelChangeWx">取 消</el-button>
            <el-button
              size="mini"
              type="primary"
              :loading="btnLoading"
              :disabled="btnLoading"
              @click="changeWx"
              >{{ is_editWx ? "保 存" : "确 定" }}</el-button
            >
          </div>
        </el-dialog>
        <!-- 添加/编辑微信用户模块 -->
        <div class="add_wxUser">
          <el-button
            type="primary"
            size="mini"
            plain
            class="add_btn"
            @click="addWxUser"
          >
            添加微信用户
          </el-button>
        </div>
        <!-- 列表 -->
        <div class="invitation_list">
          <el-table
            v-load="wxUser_loading"
            :data="wxUser_list"
            style="width: 100%"
            :height="320"
            stripe
          >
            <el-table-column label="激活状态">
              <template slot-scope="scope">
                <span
                  style="color: #999;"
                  v-if="scope.row.isActivate != 1 && scope.row.isActivate != -1"
                  >未激活</span
                >
                <span style="color: #67C23A;" v-if="scope.row.isActivate == 1"
                  >已激活</span
                >
                <span style="color: #f00;" v-if="scope.row.isActivate == -1"
                  >已过期</span
                >
              </template>
            </el-table-column>
            <el-table-column label="邀请码">
              <template slot-scope="scope">
                <span
                  style="cursor: pointer;"
                  v-clipboard:copy="scope.row.usercode"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  {{ scope.row.usercode }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="createname" label="使用人">
            </el-table-column>
            <el-table-column prop="nickName" label="微信昵称">
            </el-table-column>
            <el-table-column label="有效时间" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="time_item">
                  <span v-if="scope.row.losestatus == 0">永久</span>
                  <span v-else>{{ scope.row.losetime }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号"> </el-table-column>
            <el-table-column prop="addon" width="170" label="创建时间">
            </el-table-column>
            <el-table-column align="right" label="操作" width="150">
              <template slot-scope="scope">
                <template>
                  <el-button
                    size="mini"
                    @click.stop="editWxUser(scope.$index, scope.row)"
                  >
                    编辑</el-button
                  >
                  <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    :hideIcon="true"
                    title="确定删除吗？"
                    @confirm="deleteWxUser(scope.$index, scope.row)"
                  >
                    <el-button slot="reference" size="mini" type="danger"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="userDet_show = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 查看预警邮箱 -->
      <el-dialog
        :title="user_name"
        top="15vh"
        width="70%"
        :visible.sync="mailboxShow"
      >
        <!-- 添加/编辑邮箱 -->
        <el-dialog
          width="40%"
          :title="!is_add ? '编辑邮箱' : '添加邮箱'"
          :close-on-click-modal="false"
          @close="cancelMeail"
          :visible.sync="emailVisible"
          append-to-body
        >
          <el-form :model="email_form" :rules="rules" ref="email_form">
            <!-- 邮箱 -->
            <el-form-item label="邮箱" prop="emailUrl">
              <el-input
                v-model="email_form.emailUrl"
                placeholder="请输入邮箱"
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelMeail">取 消</el-button>
            <el-button
              type="primary"
              :loading="btnLoading"
              :disabled="btnLoading"
              @click="saveMeail"
              >{{ !is_add ? "保 存" : "确 定" }}</el-button
            >
          </div>
        </el-dialog>

        <div class="add_wxUser">
          <el-button
            type="primary"
            size="mini"
            plain
            class="add_btn"
            @click="addMailBox"
          >
            添加邮箱
          </el-button>
        </div>
        <!-- 列表 -->
        <div class="invitation_list">
          <el-table
            v-load="email_loading"
            :data="email_list"
            style="width: 100%"
            :height="320"
            stripe
          >
            <el-table-column prop="emailUrl" label="邮箱"> </el-table-column>
            <el-table-column prop="userName" label="用户"> </el-table-column>
            <el-table-column align="right" label="操作" width="150">
              <template slot-scope="scope">
                <template>
                  <el-button size="mini" @click.stop="editEmail(scope.row)">
                    编辑</el-button
                  >
                  <el-popconfirm
                    confirmButtonText="确定"
                    cancelButtonText="取消"
                    :hideIcon="true"
                    title="确定删除吗？"
                    @confirm="delMeailReq(scope.row.id, scope.$index)"
                  >
                    <el-button slot="reference" size="mini" type="danger"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      btnLoading: false,
      searchFrom: {
        user_name: "",
        login_name: "",
        company_id: "",
        createname: ""
      },
      company_list: [], // 公司列表
      search_companyList: [], // 公司列表(筛选用)
      dialogFormVisible: false,
      userDet_show: false,
      changePwd_show: false,
      is_add: true,
      // 表单
      ruleForm: {
        userid: "",
        username: "",
        companyid: "",
        companyName: "",
        losestatus: "0", // 0.永久用户，1.短期用户
        losetime: "", // 失效时间
        loginname: "",
        password: "",
        createname: "",
        desc: "",
        phone: "",
        isMatrix: "0"
      },
      pwdForm: {
        pwd: ""
      },
      // 表单检验规则
      rules: {
        userid: [{ required: true, message: "请输入用户id", trigger: "blur" }],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        companyid: [{ required: true, message: "请选择公司", trigger: "blur" }],
        loginname: [
          { required: true, message: "请输入登陆账号", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入登陆密码", trigger: "blur" }
        ],
        // createname: [
        //     { required: true, message: '请输入使用人', trigger: 'blur' },
        // ],
        pwd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        losetime: [{ required: false, message: "请选择日期", trigger: "blur" }],
        emailUrl: [{ required: false, message: "请输入邮箱", trigger: "blur" }]
      },
      dialog_top: "1vh",
      row_index: 0,
      user_id: "",
      id: "",
      user_code: "",
      wxList_index: 0,
      user_name: "",
      companyname: "",
      wxName_form: {
        createname: "",
        phone: "",
        losetime: "",
        losestatus: "0"
      },
      wxUser_loading: false,
      wxUser_list: [],
      is_init: false,
      switch_val: true,
      is_editWx: false,
      wxUser_info: {},
      innerVisible: false,

      // 邮箱预警
      mailboxShow: false,
      email_loading: false,
      emailVisible: false,
      email_list: [],
      email_form: {
        emailUrl: ""
      }
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    companyId() {
      return this.$store.state.companyId;
    }
  },
  watch: {
    userDet_show(val) {
      if (!val) {
        this.tableData[this.row_index].userWxSum = this.wxUser_list.length;
      }
    }
  },
  activated() {
    this.getCompanyList();
  },
  methods: {
    initList() {
      this.is_init = true;
      this.searchFrom = {
        user_name: "",
        login_name: "",
        company_id: "",
        createname: ""
      };
      this.page = 1;
      this.getList();
    },
    // 获取用户列表
    getList(type = "") {
      if (!this.authority) return;
      this.loading = true;
      this.tableScrollTop();
      if (!this.isAdmin) this.searchFrom.company_id = this.companyId;
      this.$http({
        url: this.$api.user_list,
        data: {
          username: this.searchFrom.user_name,
          // loginname: this.searchFrom.login_name,
          // createname: this.searchFrom.createname,
          companyid: this.searchFrom.company_id,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        this.is_init = false;
        if (res.code == 0) {
          if (type == "search") {
            if (res.data.total == 0) this.$message("没有搜索到用户");
          }
          this.total = res.data.total;
          this.tableData = res.data.concent;
        }
      });
    },
    // 获取公司列表
    getCompanyList() {
      this.$http({
        url: this.$api.company_list
      }).then(res => {
        if (res.code == 0) {
          if (!this.isAdmin) {
            res.data.forEach(val => {
              if (this.companyId == val.companyid) {
                this.company_list = [val];
                this.search_companyList = [val];
              }
            });
          } else {
            this.company_list = res.data;
            this.search_companyList = JSON.parse(JSON.stringify(res.data));
            this.search_companyList.unshift({
              companyid: "0",
              companyname: "全部"
            });
          }
        }
      });
    },
    // 获取用户微信列表
    getWxList() {
      this.wxUser_loading = true;
      this.$http({
        url: this.$api.wx_list,
        data: {
          userid: this.user_id
        }
      }).then(res => {
        this.wxUser_loading = false;
        if (res.code == 0) {
          this.wxUser_list = [];
          res.data.forEach(val => {
            if (val.losestatus != 0) {
              if (new Date() * 1 > new Date(val.losetime) * 1)
                val.isActivate = -1;
            }
            this.wxUser_list.push(val);
          });
        }
      });
    },
    // 添加/编辑微信用户
    addWxUserReq() {
      this.btnLoading = true;
      let formData = JSON.parse(JSON.stringify(this.wxName_form));
      let url = this.$api.add_wxUser;
      let data = {
        userid: this.user_id,
        createname: formData.createname,
        phone: formData.phone,
        losetime: formData.losetime,
        losestatus: formData.losestatus
      };
      if (this.is_editWx) {
        url = this.$api.edit_wxUser;
        data.usercode = formData.usercode;
        data.id = formData.id;
      }
      this.$http({
        url,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.innerVisible = false;
          this.$refs.wxName_form.resetFields();
          this.wxName_form.losetime = "";
          this.wxName_form.losestatus = "0";
          this.$refs["wxName_form"].clearValidate(["losetime"]);
          let hint_text = "添加成功";
          if (this.is_editWx) hint_text = "保存成功";
          this.$hint(hint_text);
          this.getWxList();
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 新增用户请求
    addUserReq(data) {
      this.btnLoading = true;
      if (data.losestatus == 0) data.losetime = "";
      this.$http({
        url: this.$api.add_user,
        data
      })
        .then(res => {
          this.btnLoading = false;
          if (res.code == 0) {
            this.cancel();
            this.initList();
            this.$hint("添加成功");
          } else {
            this.$hint(res.code + res.message, "err");
          }
        })
        .catch(err => {
          this.$hint("添加失败", "err");
        });
    },
    // 删除用户请求
    delUserReq() {
      this.$http({
        url: this.$api.del_user + "/" + this.user_id,
        method: "get"
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(this.row_index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint("删除失败", "err");
        }
      });
    },
    // 删除微信用户请求
    deleteWxUser(index, row) {
      this.$http({
        url: this.$api.del_wxUser,
        data: {
          id: row.id,
          unionid: row.unionid || "",
          userid: String(this.user_id)
        }
      }).then(res => {
        if (res.code == 0) {
          this.wxUser_list.splice(index, 1);
          this.$hint("删除成功");
        } else {
          this.$hint(res.code + res.message, "err");
        }
      });
    },
    // 编辑用户请求
    editUser(data) {
      this.btnLoading = true;
      this.$http({
        url: this.$api.edit_user,
        data: {
          userid: data.userid,
          loginname: data.loginname,
          username: data.username,
          companyid: data.companyid,
          desc: data.desc,
          isMatrix: data.isMatrix,
          id: data.id
        }
      })
        .then(res => {
          this.btnLoading = false;
          if (res.code == 0) {
            this.cancel();
            this.$set(this.tableData, this.row_index, data);
            this.$hint("保存成功");
          } else {
            this.$hint(res.code + res.message, "err");
          }
        })
        .catch(err => {
          this.$hint("保存失败！", "err");
        });
    },
    // 修改用户密码请求
    editPwdReq() {
      this.btnLoading = true;
      this.$http({
        url: this.$api.edit_pwd,
        data: {
          userid: this.user_id,
          password: this.pwdForm.pwd,
          id: this.id
        }
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.changePwd_show = false;
          this.$hint(res.message);
          this.$alert(this.pwdForm.pwd, "您已修改密码为", {
            confirmButtonText: "确定",
            showClose: false,
            closeOnClickModal: false,
            callback: action => {
              this.$refs.pwdForm.resetFields();
            }
          });
        } else {
          this.$hint("修改失败", "err");
        }
      });
    },
    // 获取邮箱列表
    getEmailList() {
      this.email_loading = true;
      this.$http({
        url: this.$api.email_list,
        data: {
          userId: this.user_id,
          pageIndex: 1,
          pageSize: 999
        }
      }).then(res => {
        this.email_loading = false;
        if (res.code == 0) {
          this.email_list = res.data.concent;
        }
      });
    },
    // 添加邮箱
    addMeailReq() {
      this.btnLoading = true;
      this.$http({
        url: this.$api.add_email,
        data: this.email_form
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.emailVisible = false;
          this.$hint("添加成功");
          this.getEmailList();
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 编辑邮箱
    editMeailReq() {
      this.btnLoading = true;
      this.$http({
        url: this.$api.edit_email,
        data: this.email_form
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          this.emailVisible = false;
          this.$hint("保存成功");
          this.getEmailList();
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 删除邮箱
    delMeailReq(id, index) {
      this.$http({
        url: this.$api.del_email,
        data: { id }
      }).then(res => {
        if (res.code == 0) {
          this.email_list.splice(index, 1);
          this.$hint("删除成功");
        } else {
          this.$hint(res.code + res.message, "err");
        }
      });
    },
    // 筛选
    // 选择公司
    selectCompany(e) {
      e == "0"
        ? (this.searchFrom.company_id = "")
        : (this.searchFrom.company_id = e);
      this.search();
    },
    // 查看用户
    lookUser(row, index) {
      this.row_index = index;
      this.user_id = row.userid;
      this.user_name = row.username;
      this.userDet_show = true;
      this.getWxList();
    },
    // 添加用户
    addUser() {
      this.dialogFormVisible = true;
      this.is_add = true;
      this.ruleForm = {
        username: "",
        companyid: "",
        companyName: "",
        loginname: "",
        desc: "",
        losestatus: "0",
        losetime: "",
        phone: "",
        isMatrix: "0"
      };
      this.rules.losetime[0].required = false;
      if (!this.isAdmin) {
        this.companyname = this.companyId;
        this.ruleForm.companyid = this.companyId;
      }
    },
    // 预警邮箱管理
    mailbox(row) {
      this.user_name = row.username;
      this.user_id = row.userid;
      this.mailboxShow = true;
      this.getEmailList();
    },
    // 点击修改密码
    clickChangePwd(index, row) {
      this.user_id = row.userid;
      this.id = row.id;
      this.changePwd_show = true;
    },
    // 确定修改密码
    cahngePwd() {
      this.$refs.pwdForm.validate(valid => {
        if (valid) {
          this.editPwdReq();
        } else {
          return false;
        }
      });
    },
    // 编辑用户
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.is_add = false;
      this.row_index = index;
      this.companyname = this.getCompanyName(row.companyid);
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.ruleForm.isMatrix = String(this.ruleForm.isMatrix);
    },
    // 确定新增、保存
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let item = JSON.parse(JSON.stringify(this.ruleForm));
          if (this.is_add) {
            // 新增
            this.addUserReq(item);
          } else {
            // 编辑
            this.editUser(item);
          }
        } else {
          return false;
        }
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.ruleForm.resetFields();
      this.ruleForm.desc = "";
      this.companyname = "";
      this.rules.losetime[0].required = false;
      this.$refs["ruleForm"].clearValidate(["losetime"]);
    },
    // 取消修改密码
    cancelChangePwd() {
      this.changePwd_show = false;
      this.$refs.pwdForm.resetFields();
    },
    // 删除用户
    handleDelete(index, row) {
      this.row_index = index;
      this.user_id = row.id;
    },
    // 确定删除用户
    confirmDelete() {
      this.delUserReq();
    },
    // 获取公司id
    getCompanyName(id) {
      let name = "";
      this.company_list.forEach(val => {
        if (val.companyid == id) name = val.companyname;
      });
      return name;
    },
    // 选择公司
    changeSelect(e) {
      this.ruleForm.companyid = e;
      this.company_list.forEach(val => {
        if (val.companyid == e) {
          this.ruleForm.companyName = val.companyname;
        }
      });
    },
    // 添加微信用户
    addWxUser() {
      this.innerVisible = true;
      this.is_editWx = false;
      this.wxName_form = {
        createname: "",
        phone: "",
        losetime: "",
        losestatus: "0"
      };
      this.rules.losetime[0].required = false;
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList("search");
    },
    // 点击编辑微信用户
    editWxUser(index, row) {
      this.innerVisible = true;
      this.is_editWx = true;
      this.wxName_form = JSON.parse(JSON.stringify(row));
    },
    switchChange(e, type) {
      e == 0
        ? (this.rules.losetime[0].required = false)
        : (this.rules.losetime[0].required = true);
      // 新增、编辑用户
      if (type == "user") {
        this.ruleForm.losestatus = e;
        if (e == 0) this.$refs["ruleForm"].clearValidate(["losetime"]);
      }
      if (type == "wx") {
        this.wxName_form.losestatus = e;
        if (e == 0) this.$refs["wxName_form"].clearValidate(["losetime"]);
      }
    },
    // 取消新增、编辑微信用户
    cancelChangeWx() {
      this.innerVisible = false;
      this.rules.losetime[0].required = false;
      this.$refs["wxName_form"].clearValidate(["losetime"]);
    },
    // 确定新增、编辑微信用户
    changeWx() {
      this.$refs.wxName_form.validate(valid => {
        if (valid) {
          if (
            Boolean(this.wxName_form.phone) &&
            !/^1[3456789]\d{9}$/.test(this.wxName_form.phone)
          ) {
            this.$hint("请输入正确的手机号", "err");
            return;
          }
          this.addWxUserReq();
        } else {
          return false;
        }
      });
    },
    // 点击添加邮箱
    addMailBox() {
      this.emailVisible = true;
      this.is_add = true;
      this.email_form = {
        userId: this.user_id,
        emailUrl: ""
      };
    },
    // 新增、编辑邮箱
    saveMeail() {
      this.$refs.email_form.validate(valid => {
        if (valid) {
          // if(!(/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email_form.emailUrl))) {
          //     this.$hint("请输入正确的邮箱","err")
          //     return
          // }
          if (this.is_add) {
            this.addMeailReq();
          } else {
            this.editMeailReq();
          }
        } else {
          return false;
        }
      });
    },
    // 点击编辑邮箱
    editEmail(row) {
      this.emailVisible = true;
      this.is_add = false;
      this.email_form = {
        id: row.id,
        userId: this.user_id,
        emailUrl: row.emailUrl
      };
    },
    // 取消新增、编辑邮箱
    cancelMeail() {
      this.emailVisible = false;
    },
    // 生成id
    createId() {
      let $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      let maxPos = $chars.length;
      let id = "";
      for (var i = 0; i < 32; i++) {
        id += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      this.$set(this.ruleForm, "userid", id.toLowerCase());
    },
    // 复制成功
    onCopy(e) {
      this.$message.success("内容已复制到剪切板！");
    },
    // 复制失败
    onError(e) {
      this.$message.error("抱歉，复制失败！");
    }
  }
};
</script>

<style>
.input_box .el-input__inner {
  height: 35px;
}
.date_item {
  height: 35px;
  margin-left: 10px;
}
.date_item > input {
  height: 100%;
}
</style>
<style lang="less" scoped>
.wx_userNum {
  .btn {
    border: none;
    color: #999;
  }
}
.add_wxUser {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
  transform: translateY(-10px);
  .el-form-item {
    margin: 0;
  }
  .input_box {
    width: 200px;
    height: 35px;
  }
  .add_btn {
    height: 30px;
    color: #fff;
    letter-spacing: 2px;
    margin-left: 10px;
    padding: 0 15px;
  }
}
.invitation_list {
  width: 100%;
}

.time_item {
  display: flex;
  align-items: center;
  > span {
    width: 140px;
    margin-right: 10px;
    white-space: nowrap;
  }
}

.btn_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.name_box {
  > li {
    font-size: 13px;
    color: #525f7f;
    margin-bottom: 20px;
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
    .title {
      font-size: 14px;
      color: #525f7f;
      font-weight: bold;
      margin-bottom: 5px;
    }
  }
}
.weixin_name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.editFrom_box {
  display: flex;
  .form_left,
  .form_right {
    flex: 1;
    box-sizing: border-box;
  }
  .form_left {
    padding-right: 30px;
    border-right: 1px solid #e6e6e6;
  }
  .form_right {
    padding-left: 30px;
  }
}

/deep/ .screening_box {
  .screen_input {
    .el-input__inner {
      width: 250px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/userList.vue